import { render, staticRenderFns } from "./KosiwonRegister.vue?vue&type=template&id=1ff1b774"
import script from "./KosiwonRegister.vue?vue&type=script&lang=js"
export * from "./KosiwonRegister.vue?vue&type=script&lang=js"
import style0 from "./KosiwonRegister.vue?vue&type=style&index=0&id=1ff1b774&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports